import {
  ADD_COMP_DISCOUNT,
  ADD_COMP_DISCOUNT_FULFILLED,
  ADD_COMP_DISCOUNT_REJECTED,
  CLEAR_COMP_DISCOUNTS,
  CLEAR_COMP_DISCOUNTS_FULFILLED,
  CLEAR_COMP_DISCOUNTS_REJECTED,
  FETCH_COMP_DISCOUNTS,
  FETCH_COMP_DISCOUNTS_FULFILLED,
  FETCH_COMP_DISCOUNTS_REJECTED,
  REMOVE_COMP_DISCOUNT,
  REMOVE_COMP_DISCOUNT_FULFILLED,
  REMOVE_COMP_DISCOUNT_REJECTED,
  REMOVE_COMP_DISCOUNTS,
  REMOVE_COMP_DISCOUNTS_FULFILLED,
  REMOVE_COMP_DISCOUNTS_REJECTED,
  RESET_COMP_DISCOUNTS,
  RESET_REMOVE_COMP_DISCOUNTS,
  SUBMIT_COMP_DISCOUNTS,
  SUBMIT_COMP_DISCOUNTS_FULFILLED,
  SUBMIT_COMP_DISCOUNTS_REJECTED,
} from './types';

export function addCompDiscount(discount, cardId) {
  return {
    type: ADD_COMP_DISCOUNT,
    payload: { discount, cardId },
  };
}

export function addCompDiscountFulfilled() {
  return {
    type: ADD_COMP_DISCOUNT_FULFILLED,
  };
}

export function addCompDiscountRejected(error) {
  return {
    type: ADD_COMP_DISCOUNT_REJECTED,
    payload: { error },
  };
}

export function clearCompDiscounts() {
  return {
    type: CLEAR_COMP_DISCOUNTS,
  };
}

export function clearCompDiscountsFulfilled() {
  return {
    type: CLEAR_COMP_DISCOUNTS_FULFILLED,
  };
}

export function clearCompDiscountsRejected(error) {
  return {
    type: CLEAR_COMP_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function fetchCompDiscounts() {
  return {
    type: FETCH_COMP_DISCOUNTS,
  };
}

export function fetchCompDiscountsFulfilled(
  availableCompDiscounts,
  appliedCompDiscounts,
  compDiscountsNotApplied,
  unavailableCompDiscounts,
  updatedCompDiscounts
) {
  return {
    type: FETCH_COMP_DISCOUNTS_FULFILLED,
    payload: {
      availableCompDiscounts,
      appliedCompDiscounts,
      compDiscountsNotApplied,
      unavailableCompDiscounts,
      updatedCompDiscounts,
    },
  };
}

export function fetchCompDiscountsRejected(error) {
  return {
    type: FETCH_COMP_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function removeCompDiscount(discountId) {
  return {
    type: REMOVE_COMP_DISCOUNT,
    payload: { discountId },
  };
}

export function removeCompDiscountFulfilled() {
  return {
    type: REMOVE_COMP_DISCOUNT_FULFILLED,
  };
}

export function removeCompDiscountRejected(error) {
  return {
    type: REMOVE_COMP_DISCOUNT_REJECTED,
    payload: { error },
  };
}

export function removeCompDiscounts(discountIds) {
  return {
    type: REMOVE_COMP_DISCOUNTS,
    payload: { discountIds },
  };
}

export function removeCompDiscountsFulfilled() {
  return {
    type: REMOVE_COMP_DISCOUNTS_FULFILLED,
  };
}

export function removeCompDiscountsRejected(error) {
  return {
    type: REMOVE_COMP_DISCOUNTS_REJECTED,
    payload: { error },
  };
}

export function resetRemoveCompDiscounts() {
  return {
    type: RESET_REMOVE_COMP_DISCOUNTS,
  };
}

export function resetCompDiscounts() {
  return {
    type: RESET_COMP_DISCOUNTS,
  };
}

export function submitCompDiscounts() {
  return {
    type: SUBMIT_COMP_DISCOUNTS,
  };
}

export function submitCompDiscountsFulfilled(receiptText) {
  return {
    type: SUBMIT_COMP_DISCOUNTS_FULFILLED,
    payload: {
      receiptText,
    },
  };
}

export function submitCompDiscountsRejected(error) {
  return {
    type: SUBMIT_COMP_DISCOUNTS_REJECTED,
    payload: {
      error,
    },
  };
}
